<template>
    <div class="Elevator_ui" :style="backImg">
        <van-tabs :type="finalDatas.layout == 'imgCard' ? 'card' : 'line'" :background="finalDatas.backgroundColor"
            @click="(name) => chooseType(name)" :class="`type-${finalDatas.layout}`" :color="finalDatas.lineColor"
            :title-inactive-color="finalDatas.color" :title-active-color="finalDatas.activeColor" v-if="finalDatas.showType!='vertical'">
            <van-tab :title="itemList.name" ref="tab" v-for="(itemList, i) in finalDatas.items" :key="i"
                :name="itemList.id" :title-style="picStyle[i]" title-class="elevator_tab">
                <template #title v-if="finalDatas.layout == 'imgCard'">
                    <div class="titleName">{{ itemList.name }}<img :src="itemList.cardIcon"
                            v-if="activeId == i && itemList.cardIcon" />
                    </div>

                </template>
                <template #title v-else><!-- {{itemList.name}} --></template>
                <div v-if="itemList.datas" class="tab-box">
                    <template v-for="(item, j) in itemList.datas">
                        <div v-if="item.type === 'headPic'">
                            <HeadPic :datas="item"></HeadPic>
                        </div>
                        <div v-if="item.type === 'area'">
                            <Area @updateArea="updateArea" :datas="item"></Area>
                        </div>
                        <!-- 轮播图 -->
                        <!-- 与区域code匹配，无区域组件，组件code未配置 -->
                        <div v-if="item.type === 'image'">
                            <CarouselSlide :datas="item"></CarouselSlide>
                        </div>
                        <div v-if="item.type === 'active'">
                            <Activity :datas="item"></Activity>
                        </div>
                        <!-- 搜索 -->
                        <div v-if="item.type === 'search'">
                            <Search :datas="item"></Search>
                        </div>
                        <!-- 链接 -->
                        <div v-if="item.type === 'columnModule' && !item.isBottom">
                            <Category :datas="item"></Category>
                        </div>
                        <!-- 滚动内容 -->
                        <div v-if="item.type === 'messagenotice' && item.items">

                            <ScrollNotice :datas="item"></ScrollNotice>
                        </div>

                        <!-- 限时抢购 -->
                        <div v-if="item.type === 'flashsale'">
                            <Flashsale :datas="item"></Flashsale>
                        </div>

                        <!-- 产品列表 -->
                        <div v-if="item.type === 'goodList'">
                            <GoodsList :datas="item" :waterFall=false></GoodsList>
                        </div>
                        <div v-if="item.type === 'advertising'">
                            <Advertising :datas="item"></Advertising>
                        </div>
                        <div v-if="item.type === 'notice'">
                            <notice :datas="item"></notice>
                        </div>
                        <!-- 标题 -->
                        <div v-if="item.type === 'title'">
                            <Title :datas="item"></Title>
                        </div>

                        <!-- margin -->
                        <div v-if="item.type === 'whitespace'">
                            <div :style="{ height: item.num + 'px', background: item.color }"></div>
                        </div>
                        <!-- textarea -->
                        <div v-if="item.type === 'textarea'">
                            <div :style='{ "padding": "0 " + item.padding + "px" }' class="textarea">
                                <v-html :content="item.text"></v-html>
                            </div>
                        </div>
                        <!-- 辅助线 -->
                        <div v-if="item.type === 'coupon'">
                            <couponReceive :datas="item"></couponReceive>
                        </div>
                        <!-- 视频 -->
                        <div v-if="item.type === 'video'">
                            <videoBox :datas="item"></videoBox>
                        </div>
                        <!-- 领取优惠券 -->
                        <div v-if="item.type === 'whiteLine'">
                            <AuxiliaryLine :datas="item"></AuxiliaryLine>
                        </div>
                        <!-- 客服 -->
                        <div v-if="item.type === 'cs'">
                            <customerService :datas="item"></customerService>
                        </div>
                        <!-- bottom nav -->

                        <div v-if="item.type === 'columnModule' && item.isBottom">
                            <Navbar :datas="item"></Navbar>
                        </div>
                        <!-- 天气 -->
                        <div v-if="item.type === 'weather'">
                            <Weather :datas="item"></Weather>
                        </div>
                        <!-- 登录 -->
                        <div v-if="item.type === 'login' && (!user || !user.memberId)">
                            <Login :datas="item"></Login>
                        </div>
                        <!-- 种草笔记 -->
                        <div v-if="item.type === 'plantGrass'">
                            <plantGrass :datas="item"></plantGrass>
                        </div>
                        <!-- 酒店商品 -->
                        <div v-if="item.type === 'hotelGoods' && config.hotelCode == '0'">
                            <hotelGoods></hotelGoods>
                        </div>
                        <!-- 侧边栏 -->
                        <div v-if="item.type === 'sideBar'">
                            <sideBar :datas="item"></sideBar>
                        </div>
                        <!-- 导航菜单 -->
                        <div v-if="item.type === 'navMenu'">
                            <NavMenu :datas="item"></NavMenu>
                        </div>
                        <!-- 拼团 -->
                        <div v-if="item.type === 'groupList'">
                            <groupList :datas="item"></groupList>
                        </div>
                        <div v-if="item.type === 'goodsType'">
                            <goodsType :datas="item"></goodsType>
                        </div>
                        <!-- 酒店预订 -->
                        <div v-if="item.type === 'hotelRoom'">
                            <hotelRoom :datas="item"></hotelRoom>
                        </div>
                        <div v-if="item.type === 'diyGoods'">
                            <diyGoods :datas="item"></diyGoods>
                        </div>
                        <div v-if="item.type === 'telephone'">
                            <telephone :datas="item"></telephone>
                        </div>
                    </template>
                </div>
            </van-tab>
        </van-tabs>
        <div class="elevatorBox" v-if="finalDatas.showType=='vertical'">
            <div class="elevatorLf">
                <div class="item" v-for="(itemList, i) in finalDatas.items" :key="i"
                    :style="activeId==i? colorActiveStyle : colorStyle" @click="chooseType(i)">
                    {{ itemList.name }}
                    <div class="bg" :style="colorActiveBgStyle" v-if="activeId==i"></div>
                </div>
            </div>
            <div class="elevatorRt" >
                <div class="elevatorRtBox" ref="outer">
                <div v-if="finalDatas.items && activeId == i" class="tab-box" v-for="(itemList, i) in finalDatas.items"
                :key="i" ref="inner">
                <template v-for="(item, j) in itemList.datas">
                    <div v-if="item.type === 'headPic'">
                        <HeadPic :datas="item"></HeadPic>
                    </div>
                    <div v-if="item.type === 'area'">
                        <Area @updateArea="updateArea" :datas="item"></Area>
                    </div>
                    <!-- 轮播图 -->
                    <!-- 与区域code匹配，无区域组件，组件code未配置 -->
                    <div v-if="item.type === 'image'">
                        <CarouselSlide :datas="item"></CarouselSlide>
                    </div>
                    <div v-if="item.type === 'active'">
                        <Activity :datas="item"></Activity>
                    </div>
                    <!-- 搜索 -->
                    <div v-if="item.type === 'search'">
                        <Search :datas="item"></Search>
                    </div>
                    <!-- 链接 -->
                    <div v-if="item.type === 'columnModule' && !item.isBottom">
                        <Category :datas="item"></Category>
                    </div>
                    <!-- 滚动内容 -->
                    <div v-if="item.type === 'messagenotice' && item.items">

                        <ScrollNotice :datas="item"></ScrollNotice>
                    </div>

                    <!-- 限时抢购 -->
                    <div v-if="item.type === 'flashsale'">
                        <Flashsale :datas="item"></Flashsale>
                    </div>

                    <!-- 产品列表 -->
                    <div v-if="item.type === 'goodList'">
                        <GoodsList :datas="item" :waterFall=false></GoodsList>
                    </div>
                    <div v-if="item.type === 'advertising'">
                        <Advertising :datas="item"></Advertising>
                    </div>
                    <div v-if="item.type === 'notice'">
                        <notice :datas="item"></notice>
                    </div>
                    <!-- 标题 -->
                    <div v-if="item.type === 'title'">
                        <Title :datas="item"></Title>
                    </div>

                    <!-- margin -->
                    <div v-if="item.type === 'whitespace'">
                        <div :style="{ height: item.num + 'px', background: item.color }"></div>
                    </div>
                    <!-- textarea -->
                    <div v-if="item.type === 'textarea'">
                        <div :style='{ "padding": "0 " + item.padding + "px" }' class="textarea">
                            <v-html :content="item.text"></v-html>
                        </div>
                    </div>
                    <!-- 辅助线 -->
                    <div v-if="item.type === 'coupon'">
                        <couponReceive :datas="item"></couponReceive>
                    </div>
                    <!-- 视频 -->
                    <div v-if="item.type === 'video'">
                        <videoBox :datas="item"></videoBox>
                    </div>
                    <!-- 领取优惠券 -->
                    <div v-if="item.type === 'whiteLine'">
                        <AuxiliaryLine :datas="item"></AuxiliaryLine>
                    </div>
                    <!-- 客服 -->
                    <div v-if="item.type === 'cs'">
                        <customerService :datas="item"></customerService>
                    </div>
                    <!-- bottom nav -->

                    <div v-if="item.type === 'columnModule' && item.isBottom">
                        <Navbar :datas="item"></Navbar>
                    </div>
                    <!-- 天气 -->
                    <div v-if="item.type === 'weather'">
                        <Weather :datas="item"></Weather>
                    </div>
                    <!-- 登录 -->
                    <div v-if="item.type === 'login' && (!user || !user.memberId)">
                        <Login :datas="item"></Login>
                    </div>
                    <!-- 种草笔记 -->
                    <div v-if="item.type === 'plantGrass'">
                        <plantGrass :datas="item"></plantGrass>
                    </div>
                    <!-- 酒店商品 -->
                    <div v-if="item.type === 'hotelGoods' && config.hotelCode == '0'">
                        <hotelGoods></hotelGoods>
                    </div>
                    <!-- 侧边栏 -->
                    <div v-if="item.type === 'sideBar'">
                        <sideBar :datas="item"></sideBar>
                    </div>
                    <!-- 导航菜单 -->
                    <div v-if="item.type === 'navMenu'">
                        <NavMenu :datas="item"></NavMenu>
                    </div>
                    <!-- 拼团 -->
                    <div v-if="item.type === 'groupList'">
                        <groupList :datas="item"></groupList>
                    </div>
                    <div v-if="item.type === 'goodsType'">
                        <goodsType :datas="item"></goodsType>
                    </div>
                    <!-- 酒店预订 -->
                    <div v-if="item.type === 'hotelRoom'">
                        <hotelRoom :datas="item"></hotelRoom>
                    </div>
                    <div v-if="item.type === 'diyGoods'">
                        <diyGoods :datas="item"></diyGoods>
                    </div>
                    <div v-if="item.type === 'telephone'">
                        <telephone :datas="item"></telephone>
                    </div>
                </template>
                </div>
             </div>
            </div>
           
        </div>
    </div>

</template>

<script>
    import {
        jAlert3
    } from "@/base/jAlert/jAlert";
    import {
        Tab,
        Tabs
    } from 'vant';
    import CarouselSlide from "@/components/polymerization/CarouselSlide.vue";
    import Category from "@/components/polymerization/Category.vue";
    import ScrollNotice from "@/components/polymerization/ScrollNotice.vue";
    import Flashsale from "@/components/polymerization/Flashsale.vue";
    import GoodsList from "@/components/polymerization/GoodsList.vue";
    import Title from "@/components/polymerization/Title.vue";
    import Navbar from "@/components/polymerization/Navbar.vue";
    import HeadPic from "@/components/polymerization/HeadPic.vue";
    import couponReceive from "@/components/polymerization/couponReceive.vue";
    import recommend from "@/components/polymerization/recommend.vue";
    import Search from "@/components/polymerization/Search.vue";
    import AuxiliaryLine from "@/components/polymerization/AuxiliaryLine.vue";
    import videoBox from "@/components/polymerization/video.vue";
    import Area from "@/components/polymerization/Area.vue";
    import notice from "@/components/polymerization/notice.vue";
    import Advertising from "@/components/polymerization/Advertising.vue";
    import Activity from "@/components/polymerization/Activity.vue";
    import plantGrass from "@/components/polymerization/plantGrass.vue";
    import customerService from "@/components/polymerization/customerService.vue";
    import Weather from "@/components/polymerization/Weather.vue";
    import Login from "@/components/polymerization/Login.vue";
    import hotelGoods from "@/components/polymerization/hotelGoods.vue";
    import sideBar from "@/components/polymerization/sideBar.vue";
    import NavMenu from "@/components/polymerization/NavMenu.vue";
    import groupList from "@/components/polymerization/groupList.vue";
    import goodsType from "@/components/polymerization/goodsType.vue";
    import hotelRoom from "@/components/polymerization/hotelRoom.vue";
    import diyGoods from "@/components/polymerization/diyGoods.vue";
    import telephone from "@/components/polymerization/telephone.vue";
    export default {
        props: {
            datas: Object
        },
        data() {
            return {
                finalDatas: {

                },
                activeId: 0
            };
        },
        methods: {
            updateOuterHeight() {
            
                const innerHeight = this.$refs.inner[0].offsetHeight* 0.78667;
                this.$refs.outer.style.height = `${innerHeight}px`;
            },
            chooseType(tab) {
                this.activeId = tab;
            }
        },
        computed: {
            colorStyle() {
                var style = "";
                style = `color:${this.finalDatas.color};font-size:${this.finalDatas.fontSize};`
                return style
            },
            colorActiveStyle() {
                var style = "";
                style = `color:${this.finalDatas.activeColor};font-size:${this.finalDatas.fontSize};` 
                return style
            },
            colorActiveBgStyle(){
                var style = "";
                style = `background:${this.finalDatas.activeColor};opacity: 0.1;` 
                return style
            },
            backImg() {
                var style = "";
                if (this.finalDatas.layout == "imgCard") {
                    style = `background:url(${this.finalDatas.items[this.activeId].cardImg}) 0 0 no-repeat;`;
                }
                return style;
            },
            picStyle() {
                var style = []
                var styleItem = ''

                this.finalDatas.items.forEach(item => {
                    if (this.finalDatas.layout != 'text' && this.finalDatas.layout != 'imgCard') {
                        styleItem = `background:url(${item.icon}) center 10px/auto 25px no-repeat;`
                    }
                    if (this.finalDatas.layout == 'imgCard') {
                        styleItem = `background:none;`
                    }
                    if (this.finalDatas.fontSize) {
                        styleItem += `font-size:${this.finalDatas.fontSize};`
                    }
                    style.push(styleItem)

                })
                return style
            }
        },
        updated(){
            if(this.finalDatas.showType=='vertical'){
                this.updateOuterHeight();
            }
            
        },
        mounted() {
            this.finalDatas = JSON.parse(JSON.stringify(this.datas))
            if (this.finalDatas.layout == "card") {
                this.finalDatas.layout = "imgCard"
                this.finalDatas.backgroundColor = ""
            }

        },
        components: {
            CarouselSlide,
            Category,
            ScrollNotice,
            Flashsale,
            GoodsList,
            Title,
            Navbar,
            HeadPic,
            couponReceive,
            recommend,
            Search,
            AuxiliaryLine,
            videoBox,
            Area,
            notice,
            Advertising,
            Activity,
            plantGrass,
            customerService,
            Weather,
            Login,
            hotelGoods,
            sideBar,
            NavMenu,
            groupList,
            goodsType,
            hotelRoom,
            diyGoods,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            telephone
        },

    }
</script>

<style lang="less" scoped>
    .Elevator_ui {
        background-size: 100% auto !important;

        /deep/.van-tab--active {
            font-weight: bold;
        }

        /deep/.type-textImg {

            .van-tabs__wrap,
            .van-tabs__nav,
            .van-tab {
                height: 62px;
            }

            .van-tabs__nav {
                .elevator_tab {

                    .van-tab__text {
                        margin-top: 33px;
                    }
                }

                .van-tabs__line {
                    display: none;
                }
            }
        }

        /deep/.type-imgCard {

            border: 0;

            .van-tabs__nav {
                background: none;
            }

            .van-tabs__wrap {
                padding: 10px 0;
                height: auto;
            }

            .van-tabs__nav--card {
                border: 0;
                height: auto;
                margin: 0;

            }

            .van-tab {
                border-right: 0;
            }

            .titleName {
                height: 48px;
                text-align: center;
                line-height: 48px;

                img {
                    margin-left: 12px;
                    max-height: 48px;
                    width: 48px;
                }
            }
        }

        /deep/.type-img {

            .van-tabs__wrap,
            .van-tabs__nav,
            .van-tab {
                height: 50px;
            }

            .elevator_tab {
                .van-tab__text {
                    display: none;
                }
            }

            .van-tabs__line {
                display: none;
            }
        }

        /deep/.type-text {

            .van-tabs__nav {
                .elevator_tab {}

                .van-tabs__line {
                    bottom: 20px;
                    height: 2px;
                }
            }
        }

        .elevatorBox {
            display: flex;
            .elevatorLf {
                padding: 0 5px;
                width: 2.133333rem;
                box-sizing: border-box;
                overflow-y: auto;
                max-height: 100vh;
                background: #FFFFFF;
                .item {
                    position: relative;
                    box-sizing: border-box;
                    padding: 5px;
                    margin-top: 10px;
                    width: 100%;
                    line-height: 1.4;
                    border-radius: 4px;
                    overflow: hidden;
                    text-align: center;
                    .bg{
                        top: 0;
                        left: 0;
                        position: absolute;
                        z-index: 0;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .elevatorRt{
                height: 100vh;
                overflow-y: auto;
                overflow-x: hidden;
                flex: 1;
                
                
                .tab-box{
                    width: 100vw;
                    transform: scale(0.78667);
                    transform-origin: left top;
                
                }
            }
            
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/polymerization/Elevator.vue